import React, { memo } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { TileAddOn, TileContent } from '@tamagoshi/core/Tile';
import Button from '@tamagoshi/core/Button';
import { getFooterContext } from '@context';
import { getTranslations } from '@translations';
import { isB2BVisible } from '@constants';
import { Title, SubTitle } from './Title';

import styles from './styles/index.module.scss';

export const B2BButton = memo(({ children, className }) => {
  const { baseUrl } = getFooterContext();
  const translations = getTranslations();
  const url = `${translations(
    'footer.account.login.url',
  )}?b2b=true&redirect_to_homepage=false`;

  return (
    <Button
      tag="a"
      theme="proMarketing"
      href={`${baseUrl}/${translations('footer.b2c.connect.pro.link')}`}
      data-qa="b2b-signin-button-footer-reinsurance-cta"
      data-url-login={`${baseUrl}${url}`}
      data-gtm-event="click_b2b_login"
      data-gtm-target="footer_reinsurance_cta"
      className={className}
    >
      {children}
    </Button>
  );
});

B2BButton.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

B2BButton.displayName = 'B2BButton';

export const B2BConnectDesktop = () => {
  const { isAuthenticated, isB2B, platform } = getFooterContext();
  const translations = getTranslations();

  if (!isB2BVisible(platform, isAuthenticated, isB2B)) return null;

  return (
    <TileAddOn justify="center" direction="column">
      <Title />
      <B2BButton className={cn(styles.button)}>
        {translations('footer.trust.pro.button.title')}&nbsp;
        {translations('footer.trust.pro.button.text')}
      </B2BButton>
      <SubTitle />
    </TileAddOn>
  );
};

B2BConnectDesktop.displayName = 'B2BConnectDesktop';

export const B2BConnectMobile = () => {
  const { isAuthenticated, isB2B, platform } = getFooterContext();
  const translations = getTranslations();

  if (!isB2BVisible(platform, isAuthenticated, isB2B)) return null;

  return (
    <>
      <TileAddOn justify="center" direction="column">
        <Title />
        <SubTitle />
      </TileAddOn>
      <TileContent className={styles.actions}>
        <B2BButton className={cn(styles.xsButton)}>
          {translations('footer.trust.pro.button.text')}
        </B2BButton>
      </TileContent>
    </>
  );
};

B2BConnectMobile.displayName = 'B2BConnectMobile';
